import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

/** Admin-only flags of an organization: is_test + per-company cliente users limit. */
export default function OrgAdminFlags({ org, onChanged }) {
  const [limit, setLimit] = useState("");
  useEffect(() => { setLimit(org?.max_cliente_users ? String(org.max_cliente_users) : ""); }, [org]);
  if (!org) return null;

  async function patch(body, msg) {
    try {
      await api.patch(`/organizations/${org.id}/admin-flags`, body);
      toast.success(msg);
      onChanged?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  }

  return (
    <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4 grid sm:grid-cols-2 gap-4" data-testid="org-admin-flags">
      <div className="flex items-center justify-between gap-3">
        <div>
          <Label className="text-sm font-semibold text-slate-800">Azienda di test</Label>
          <p className="text-[11px] text-slate-500">Esclusa dai contatori; P.IVA non validata.</p>
        </div>
        <Switch checked={!!org.is_test} onCheckedChange={(v) => patch({ is_test: v }, v ? "Azienda marcata come test" : "Azienda non più di test")} data-testid="org-is-test-switch" />
      </div>
      <div>
        <Label className="text-sm font-semibold text-slate-800">Limite utenti cliente (eccezione)</Label>
        <div className="flex gap-2 mt-1">
          <Input type="number" min={0} max={50} value={limit} placeholder={`Generale (${org.max_cliente_users_effective ?? "—"})`}
                 onChange={(e) => setLimit(e.target.value)} className="h-9" data-testid="org-max-users-input" />
          <Button size="sm" variant="outline" data-testid="org-max-users-save"
                  onClick={() => patch({ max_cliente_users: Number(limit) || 0 }, "Limite utenti aggiornato")}>Salva</Button>
        </div>
        <p className="text-[11px] text-slate-500 mt-1">Vuoto = valore generale definito in Impostazioni.</p>
      </div>
    </div>
  );
}
